import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// Calendar
const Calendar = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Calendar/Calendar.vue");
// Charts
const Charts = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Charts.vue");

// Components pages
const Buttons = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Buttons.vue");
const Cards = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Cards.vue");
const GridSystem = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/GridSystem.vue"
  );
const Notifications = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/Notifications.vue"
  );
const Icons = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Icons.vue");
const Typography = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/Typography.vue"
  );

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");
const AlternativeDashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/Dashboard/AlternativeDashboard.vue"
  );
const Widgets = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Widgets.vue");

// Forms pages
const FormElements = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormElements.vue");
const FormComponents = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormComponents.vue");
const FormValidation = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormValidation.vue");

// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Maps/GoogleMaps.vue");
const VectorMaps = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Maps/VectorMaps.vue");

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile.vue");
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Pricing.vue");
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/TimeLinePage.vue");
const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");
const Home = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Home.vue");
const Register = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Register.vue");
const Lock = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Lock.vue");
const Recuperar = () => import("@/views/Pages/Recuperar.vue");
// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/RegularTables.vue");
const SortableTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/SortableTables.vue");
const PaginatedTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/PaginatedTables.vue");

const UsersManagement = () =>
  import("@/views/AdminUsersPermissions/UsersManagement.vue");
const DashboardVentas = () =>
  import("@/views/VentasPlanes/DashboardVentas.vue");
const PanelVentas = () => import("@/views/VentasPlanes/PanelVentas.vue");
const NuevaVenta = () => import("@/views/VentasPlanes/NuevaVenta.vue");
const NuevaVentaGmoPeru = () =>
  import("@/views/VentasPlanes/NuevaVentaGmoPeru.vue");
//Planes
const PlanesManagement = () => import("@/views/Planes/PlanesManagement.vue");
const CategoriesManagement = () =>
  import("@/views/Categories/CategoriesManagement.vue");
const SubcategoriesManagement = () =>
  import("@/views/Subcategories/SubcategoriesManagement.vue");
// Usuarios & Permisos
const TeamsManagement = () =>
  import("@/views/AdminUsersPermissions/TeamsManagement.vue");
const BranchsManagement = () =>
  import("@/views/AdminUsersPermissions/BranchsManagement.vue");
const SponsorsManagement = () =>
  import("@/views/AdminUsersPermissions/SponsorsManagement.vue");
// Materias
const MateriasManagement = () =>
  import("@/views/Materias/MateriasManagement.vue");
// Carro de Ventas
const CartManagement = () => import("@/views/Cart/CartManagement.vue");

// Siniestros
const IngresarSiniestro = () =>
  import("@/views/Siniestros/IngresarSiniestro.vue");
// reportes
const ReportesSponsor = () => import("@/views/Reportes/ReportesSponsor.vue");
const ReportesCompañia = () => import("@/views/Reportes/ReportesCompañia.vue");
const ReportesSiniestros = () =>
  import("@/views/Reportes/ReportesSiniestros.vue");
// Registro de Actividad
const RegistroActividad = () =>
  import("@/views/Registro/RegistroActividad.vue");


const PanelGuarantees = () => import("@/views/Guarantees/PanelGuarantees.vue");


import store from "@/stores/store";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      component: Buttons
    },
    {
      path: "cards",
      name: "Cards",
      component: Cards
    },
    {
      path: "grid-system",
      name: "Grid System",
      component: GridSystem
    },
    {
      path: "notifications",
      name: "Notifications",
      component: Notifications
    },
    {
      path: "icons",
      name: "Icons",
      component: Icons
    },
    {
      path: "typography",
      name: "Typography",
      component: Typography
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/elements",
  name: "Forms",
  children: [
    {
      path: "elements",
      name: "Form elements",
      component: FormElements
    },
    {
      path: "components",
      name: "Form components",
      component: FormComponents
    },
    {
      path: "validation",
      name: "Form validation",
      component: FormValidation
    }
  ]
};

let tablesMenu = {
  path: "/tables",
  component: DashboardLayout,
  redirect: "/table/regular",
  name: "Tables menu",
  children: [
    {
      path: "regular",
      name: "Tables",
      component: RegularTables
    },
    {
      path: "sortable",
      name: "Sortable",
      component: SortableTables
    },
    {
      path: "paginated",
      name: "Paginated Tables",
      component: PaginatedTables
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      component: GoogleMaps
    },
    {
      path: "vector",
      name: "Vector Map",
      component: VectorMaps
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "user",
      name: "User Page",
      component: User
    },
    {
      path: "timeline",
      name: "Timeline Page",
      component: TimeLine
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLoggedIn) {
          next({ name: "Ingresar Venta" });
        }
        next();
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/recuperar",
      name: "Rercuperar",
      component: Recuperar
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    },
    { path: "*", component: NotFound }
  ]
};

let rutasUsuariosPermisos = {
  path: "/admin",
  component: DashboardLayout,
  redirect: "/admin/usuarios",
  name: "Usuarios & Permisos",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "usuarios",
      name: "Gestionar Usuarios",
      component: UsersManagement
    },
    {
      path: "equipos",
      name: "Gestionar Equipos",
      component: TeamsManagement
    },
    {
      path: "sucursales",
      name: "Gestionar Sucursales",
      component: BranchsManagement
    },
    {
      path: "sponsors",
      name: "Gestionar Sponsors",
      component: SponsorsManagement
    }
  ]
};

let rutasVentas = {
  path: "/ventas",
  component: DashboardLayout,
  redirect: "/ventas/",
  name: "Ventas",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "/",
      name: "Dashboard Ventas",
      component: PanelVentas
    },
    {
      path: "crear",
      name: "Ingresar Venta",
      component: NuevaVenta
    },
    {
      path: "gmo-peru",
      name: "Ingresar Venta GMO Peru",
      component: NuevaVentaGmoPeru
    }
  ]
};

let rutasPlanesManagement = {
  path: "/planes",
  component: DashboardLayout,
  redirect: "/planes/",
  name: "Planes",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "/",
      name: "Dashboard Planes",
      component: PlanesManagement
    },
    {
      path: "categorias",
      name: "Dashboard Categorias",
      component: CategoriesManagement
    },
    {
      path: "subcategorias",
      name: "Dashboard Subcategorias",
      component: SubcategoriesManagement
    }
  ]
};

let rutasMateriasManagement = {
  path: "/materias",
  component: DashboardLayout,
  redirect: "/materias/",
  name: "Materias",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "/",
      component: MateriasManagement
    }
  ]
};

let rutasActividad = {
  path: "/actividad",
  component: DashboardLayout,
  redirect: "/actividad/",
  name: "Registro de Actividad",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "/",
      component: RegistroActividad
    }
  ]
};

let rutasCartManagement = {
  path: "/carro",
  component: DashboardLayout,
  redirect: "/carro/",
  name: "Carro",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "/",
      component: CartManagement
    }
  ]
};

let rutasSiniestros = {
  path: "/siniestros",
  component: DashboardLayout,
  redirect: "/siniestros/ingresar",
  name: "Siniestros",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "ingresar",
      component: IngresarSiniestro,
      name: "Ingresar Siniestro"
    }
  ]
};
let rutasReportes = {
  path: "/reportes",
  component: DashboardLayout,
  redirect: "/reportes/sponsor",
  name: "Reportes",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "sponsor",
      component: ReportesSponsor,
      name: "Reportes Sponsor"
    },
    {
      path: "compañia",
      component: ReportesCompañia,
      name: "Reportes Compañia"
    },
    {
      path: "siniestros",
      component: ReportesSiniestros,
      name: "Reportes Siniestros"
    }
  ]
};

let rutasGuarantees = {
  path: "/garantias",
  component: DashboardLayout,
  redirect: "/g/",
  name: "Garantias",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "/",
      name: "Lista Garantias",
      component: PanelGuarantees
    },
  ]
};

const routes = [
  {
    path: "/",
    redirect: { name: "Ingresar Venta" }
    //name: 'Home'
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard layout",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "alternative",
        name: "Alternative",
        component: AlternativeDashboard,
        meta: {
          navbarType: "light",
          requiresAuth: true
        }
      },
      {
        path: "calendar",
        name: "Calendar",
        component: Calendar
      },
      {
        path: "charts",
        name: "Charts",
        component: Charts
      },
      {
        path: "widgets",
        name: "Widgets",
        component: Widgets
      }
    ]
  },
  rutasUsuariosPermisos,
  rutasVentas,
  rutasPlanesManagement,
  rutasMateriasManagement,
  rutasActividad,
  rutasCartManagement,
  rutasSiniestros,
  rutasReportes,
  rutasGuarantees,
  // IMPORTANTE: Este tiene que estar al ultimo porque hay un path que es generico (*) y carga la vista Not Found para cualquier ruta
  authPages
];

export default routes;
